import 'App.css';
import { Routes, Route } from 'react-router-dom';
import SignIn from 'Pages/SignIn';
import Home from 'Pages/Home';
// import Statistic from 'Pages/Statistic';
import Notice from 'Pages/Notice';
import Manage from 'Pages/Manage';
import AdminManage from 'Pages/AdminManage';
import Inquiry from 'Pages/Inquiry';
import Coupon from 'Pages/Coupon';
import Subscription from 'Pages/Subscription';
import MarkQNA from 'Pages/MarkQNA';
import PopUp from 'Pages/PopUp';
import Product from 'Pages/Product';
import Service from 'Pages/Service';
import ErrorPage from 'Pages/ErrorPage';
import USACache from 'Pages/USACache';
import AdminOrder from 'Pages/AdminOrder';

function App() {
  return (
    <div className='App'>
      <Routes>
        <Route path='/' element={<SignIn />} />
        <Route path='/home' element={<Home />} />
        {/* <Route path='/statistic' element={<Statistic />} /> */}
        <Route path='/manage' element={<Manage />} />
        <Route path='/admin-manage' element={<AdminManage />} />
        <Route path='/inquiry' element={<Inquiry />} />
        <Route path='/notice' element={<Notice />} />
        <Route path='/product' element={<Product />} />
        <Route path='/service' element={<Service />} />
        <Route path='/mark-qna' element={<MarkQNA />} />
        <Route path='/popup' element={<PopUp />} />
        <Route path='/event' element={<Coupon />} />
        <Route path='/subscription' element={<Subscription />} />
        <Route path='/admin-orders' element={<AdminOrder />} />
        <Route path='/usa-cache' element={<USACache />} />
        <Route path='*' element={<ErrorPage />} />
      </Routes>
    </div>
  );
}

export default App;
